import React from 'react';
import { Card, ProgressBar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

/**
 * RetentionCard - Tarjeta para mostrar tasa de retención
 * @param {number} rate - Tasa de retención (0-100)
 * @param {number} returningCustomers - Cantidad de clientes recurrentes
 * @param {number} totalCustomers - Total de clientes activos
 */
const RetentionCard = ({ rate = 0, returningCustomers = 0, totalCustomers = 0 }) => {
    const { t } = useTranslation();

    const getVariant = (value) => {
        if (value >= 50) return 'success';
        if (value >= 25) return 'info';
        if (value >= 10) return 'warning';
        return 'danger';
    };

    return (
        <Card className="h-100">
            <Card.Body>
                <Card.Title>{t('dashboard.customerRetention')}</Card.Title>
                <div className="text-center my-4">
                    <div className="display-4 fw-bold mb-2">
                        {rate}%
                    </div>
                    <p className="text-muted mb-3">
                        {t('dashboard.retentionDescription', {
                            returning: returningCustomers,
                            total: totalCustomers
                        })}
                    </p>
                    <ProgressBar
                        now={rate}
                        variant={getVariant(rate)}
                        style={{ height: '10px' }}
                    />
                </div>
                <div className="small text-muted mt-3">
                    <i className="bi bi-info-circle me-1"></i>
                    {t('dashboard.retentionTooltip')}
                </div>
            </Card.Body>
        </Card>
    );
};

export default RetentionCard;
